module.exports = __webpack_public_path__ + "static/media/terraform_associate.379d8387.png";